import { first, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { InboxService, Inbox } from '@app/_components/inbox';
import { environment } from '@environments/environment';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InboxComponent } from '../inbox/inbox.component';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertService, AuthenticationService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService, FilterService, MenuItem, TreeNode, SelectItem, FilterMatchMode } from 'primeng/api';
import { User } from '@app/_models';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { TaskComponent } from '@app/_components/task/task/task.component';
import { ImapUserMappingService } from '@app/_components/imap-user-mapping/imap-user-mapping.service';
import { ImapConfigurationService } from '@app/_components/imap-configuration/imap-configuration.service';
import { Msg, MsgService } from '@app/_components/msg';
import { TagService } from '@app/_components/tag/tag.service';
import { TagComponent } from '@app/_components/tag/tag/tag.component';
import { TaskListComponent } from '@app/_components/task/task-list/task-list.component';
import { InboxSmsComponent } from '@app/_components/inbox/inbox-sms/inbox-sms.component';
import { ConversationComponent } from '@app/_components/inbox/conversation/conversation.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ImapConfiguration } from '@app/_components/imap-configuration/imap-configuration';
import { InboxMailSMsComponent } from '@app/_components/inbox/inbox-mail-sms/inbox-mail-sms.component';
import { MsgTemplateData } from '@app/_components/msg-template/msg-template-data';
import { ActivatedRoute } from '@angular/router';
import { Calendar } from 'primeng/calendar';

@Component({
    selector: 'app-inbox-list-vertical',
    templateUrl: './inbox-list-vertical.component.html',
    styleUrls: ['./inbox-list-vertical.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class InboxListVerticalComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();
  cols: { field: string; header: string; }[];
  tableData: any[] = [];
  allInboxes: any;
  childInboxesData: any;
  currentUser: User;
  currentUserSubscription: Subscription;
  mailBoxes: SelectItem[];
  selectedmailbox = '3';
  selectedNode: TreeNode;
  items: MenuItem[];
  msgContextIds: any[];
  msgSubContextIds: any[];
  msgRoleIds: any[];
  msgOriginIds: any[];
  openingReservation: { [key: number]: boolean } = {};
  archivingMsgIds = new Set<number>();
  restoringMsgIds = new Set<number>();
  isBulkArchiving = false;
  isBulkUnarchiving = false;
  msgContextColors: { [key: number]: string } = {
    0: 'text-secondary fw-bold',
    1: 'text-primary fw-bold',
    2: 'text-success fw-bold',
    3: 'text-danger fw-bold',
    4: 'text-warning fw-bold',
    5: 'text-info fw-bold',
    6: 'text-dark fw-bold',
    7: 'text-blue fw-bold', // Custom class
    8: 'text-orange fw-bold' // Custom class
  };
  msgSubContextColors: { [key: number]: string } = {
    0: 'text-secondary fw-bold',
    1001: 'text-primary fw-bold',
    2001: 'text-success fw-bold',
    3001: 'text-danger fw-bold'
  };
  msgOriginColors: { [key: number]: string } = {
    0: 'text-primary fw-bold',
    1: 'text-success fw-bold',
    2: 'text-info fw-bold',
    3: 'text-warning fw-bold',
    4: 'text-dark fw-bold',
    5: 'text-blue fw-bold',
    6: 'text-orange fw-bold'
  };
  msgRoleColors: { [key: number]: string } = {
    0: 'text-blue fw-bold',  // DEFAULT
    1: 'text-primary fw-bold',    // OWNER
    2: 'text-success fw-bold',    // GUEST
    3: 'text-info fw-bold',       // TRAVEL_AGT
    4: 'text-warning fw-bold',    // EMPLOYEE
    5: 'text-danger fw-bold'      // VENDOR
  };
  selectedMails: any[] = [];
  private inobxes: any[];
  msg: Msg;
  selectedMailEntry: any;
  selectAllCheckbox = false;
  showUnread = true;
  @Input() msgTopic: number;
  @Input() defaultImapConfId: number;
  @Input() msgTopicId: number;
  @Input() msgTemplateData: MsgTemplateData;
  @Input() ownerEmail: any;
  @Input() ownerMobile: any;
  @Input() msgContext: any;
  @Input() msgSubContext: any;
  @Input() orderId: any;
  @Input() mobilePhone: any;
  @Input() reservations: any;
  @Input() order: any;
  @Input() templateMsgAudience: any;
  selectedRowIndex: number;
  selectedRow: Inbox;
  //  searchKeyWork: any;
  mailPaneLoading = false;
  goToPageNumber: number = 1;
  rowsPerPage: number = 50;
  statementIdFromQuery: string | null = null;
  ownerProfileIdFromQuery: string | null = null;
  propertyProfileIdFromQuery: string | null = null;
  @ViewChild('pt') pt: any;
  @ViewChild('messageListWrapper') messageListWrapper!: ElementRef;
  @ViewChild(InboxSmsComponent) inboxSmsComponent!: InboxSmsComponent;
  @ViewChild(ConversationComponent) conversationComponent!: ConversationComponent;
  msgStartDate: Date | null = null;
  msgEndDate: Date | null = null;
  minEndDate: Date | null = null; // Minimum selectable end date
  searchKeyWork: any = '';
  searchKeyFilter: string = 'email';

  baseSearchFilterOptions = [
    { label: 'Email', value: 'email' },
    { label: 'Subject', value: 'subject' },
    { label: 'Rez.Id', value: 'reservationId' },
    { label: 'Phone', value: 'phone' },
  ];
  searchSuggestions: { label: string; value: string }[] = [];
  searchPlaceholder: string = 'Search (min 3 chars)...';
  @ViewChild('endCal') endCal!: Calendar;
  @ViewChild('leftSidebar') leftSidebarRef!: ElementRef<HTMLDivElement>;
  @ViewChild('mainContainer') mainContainerRef!: ElementRef<HTMLDivElement>;
  leftSidebarWidth = 20;
  private isResizingSidebar = false;
  private resizeStartX = 0;
  private resizeStartWidthPx = 0;

  get leftSidebarFlex(): string {
    return `0 0 ${this.leftSidebarWidth}%`;
  }
  reservationOptions: any[] = [];

  notificationCount = 0;
  notifications: any[] = [];
  private notificationStreamController: AbortController | null = null;
  private pendingNotificationMsgId: number | null = null;
  private isSilentRefresh = false;

  private starSubject = new Subject<void>();
  private pendingStarChanges = new Map<number, boolean>();

  msgTagsMap: { [msgId: number]: any[] } = {};

  allTags: any[] = [];
  selectedTagIds: number[] = []; 
  selectedTag: any = null;

  recentSearches: string[] = [];
  searchFocused = false;
  private readonly RECENT_SEARCHES_KEY = 'kbm_inbox_recent_searches';

  constructor(
    private inboxService: InboxService,
    private imapConfigurationService: ImapConfigurationService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    public datePipe: DatePipe,
    private msgService: MsgService,
    private tagService: TagService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef
  ) {
    this.statuses = inboxService.statuses;
    this.msgContexts = inboxService.msgContexts;
    this.msgSubContextMap = inboxService.msgSubContextMap;
    this.msgRoles = inboxService.msgRoles;
    this.msgOrigin = inboxService.msgOrigin;
    this.msgOriginFiltered = inboxService.msgOriginFiltered;
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
    this.leftSidebarWidth = 20;
    try {
      this.mailBoxes = [];

      this.mailBoxes.push({ label: 'Inbox', icon: 'pi pi-envelope', styleClass: 'p-button-info', value: '3' });
      this.mailBoxes.push({ label: 'Sentbox', icon: 'pi pi-send', styleClass: 'p-button-info', value: '2' });
      this.mailBoxes.push({ label: 'Draft', icon: 'pi pi-file-o', styleClass: 'p-button-info', value: '1' });
      this.mailBoxes.push({ label: 'Outbox', icon: 'pi pi-exclamation-triangle', styleClass: 'p-button-info', value: '5' });
      this.mailBoxes.push({ label: 'Archived', icon: 'pi pi-arrow-circle-down', styleClass: 'p-button-info', value: '0' });
      this.mailBoxes.push({ label: 'Starred', icon: 'pi pi-star-fill', styleClass: 'p-button-info', value: 'starred' });

    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
    try {
      if (this.route?.snapshot?.params['msgTopic']) {
        this.msgTopic = this.route.snapshot.params['msgTopic'];
      }
      if (this.route?.snapshot?.params['defaultImapConfId']) {
        this.defaultImapConfId = this.route.snapshot.params['defaultImapConfId'];
      }
      if (this.route?.snapshot?.params['contextId']) {
        this.msgContext = this.route.snapshot.params['contextId'];
      }
      if (this.route?.snapshot?.params['subContextId']) {
        this.msgSubContext = this.route.snapshot.params['subContextId'];
      }
    } catch (e) { }
  }

  onSidebarResizeStart(event: MouseEvent): void {
    if (!this.leftSidebarRef || !this.mainContainerRef) {
      return;
    }
    this.isResizingSidebar = true;
    this.resizeStartX = event.clientX;
    this.resizeStartWidthPx = this.leftSidebarRef.nativeElement.getBoundingClientRect().width;
    event.preventDefault();
  }

  @HostListener('window:mousemove', ['$event'])
  onWindowMouseMove(event: MouseEvent): void {
    if (!this.isResizingSidebar || !this.mainContainerRef) {
      return;
    }
    const containerRect = this.mainContainerRef.nativeElement.getBoundingClientRect();
    const containerWidth = containerRect.width || 1;
    const deltaX = event.clientX - this.resizeStartX;
    let newWidthPx = this.resizeStartWidthPx + deltaX;

    const minPx = containerWidth * 0.12;
    const maxPx = containerWidth * 0.60;
    if (newWidthPx < minPx) newWidthPx = minPx;
    if (newWidthPx > maxPx) newWidthPx = maxPx;

    const newPercent = (newWidthPx / containerWidth) * 100;
    this.leftSidebarWidth = Math.max(12, Math.min(60, +newPercent.toFixed(2)));
  }

  @HostListener('window:mouseup')
  onWindowMouseUp(): void {
    this.isResizingSidebar = false;
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  @Input() isDialog = false;
  inboxs: any[] = [];
  parents: any[] = [];
  children: any[] = [];
  inbox: any;
  mailselectCheckBox = false;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;
  msgContexts: any;
  msgSubContextMap: any;
  msgSubContextsFiltered: any[] = [];
  msgRoles: any;
  msgOrigin: any;
  msgOriginFiltered: any;
  columns: any[] = [
    { field: 'senderName', header: 'Sender Name', width: 'auto' },
    { field: 'senderEmail', header: 'Sender Email', width: 'auto' },
    { field: 'subject', header: 'subject', width: 'auto' },
  ];

  onMessageTabChange(event: MatTabChangeEvent): void {
    if (event?.tab?.textLabel === 'SMS' && this.inboxSmsComponent) {
      setTimeout(() => {
        this.inboxSmsComponent.scrollToBottom();
      }, 0);
    }
  }


  tableData1 = [

    // ================= 1 MONTH BEFORE ARRIVAL =================
    { section: '1 Month Before Arrival', templateId: 842, title: 'GUEST_MAUI_1_MONTH_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },

    // ================= 2 WEEKS BEFORE ARRIVAL =================
    { section: '2 Weeks Before Arrival', templateId: 242, title: 'GUEST_PARKCITY_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '2 Weeks Before Arrival', templateId: 189, title: 'GUEST_HAWAII_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '2 Weeks Before Arrival', templateId: 97, title: 'GUEST_CONCIERGE_HAWAII_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '2 Weeks Before Arrival', templateId: 240, title: 'HOMEOWNER_GUEST_PARKCITY_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '2 Weeks Before Arrival', templateId: 246, title: 'HOMEOWNER_GUEST_HAWAII_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '2 Weeks Before Arrival', templateId: 248, title: 'HOMEOWNER_PARKCITY_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '2 Weeks Before Arrival', templateId: 244, title: 'HOMEOWNER_HAWAII_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '2 Weeks Before Arrival', templateId: 848, title: 'GUEST_MISSING_DETAILS_2_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },

    // ================= 1 WEEK BEFORE ARRIVAL =================
    { section: '1 Week Before Arrival', templateId: 304, title: 'GUEST_PARKCITY_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '1 Week Before Arrival', templateId: 192, title: 'GUEST_HAWAII_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Week Before Arrival', templateId: 302, title: 'HOMEOWNER_GUEST_PARKCITY_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Week Before Arrival', templateId: 300, title: 'HOMEOWNER_GUEST_HAWAII_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '1 Week Before Arrival', templateId: 334, title: 'HOMEOWNER_PARKCITY_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Week Before Arrival', templateId: 330, title: 'HOMEOWNER_HAWAII_1_WEEK_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= 3 DAYS BEFORE ARRIVAL =================
    { section: '3 Days Before Arrival', templateId: 308, title: 'GUEST_PARKCITY_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '3 Days Before Arrival', templateId: 256, title: 'GUEST_HAWAII_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '3 Days Before Arrival', templateId: 306, title: 'HOMEOWNER_GUEST_PARKCITY_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '3 Days Before Arrival', templateId: 258, title: 'HOMEOWNER_GUEST_HAWAII_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '3 Days Before Arrival', templateId: 336, title: 'HOMEOWNER_PARKCITY_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '3 Days Before Arrival', templateId: 332, title: 'HOMEOWNER_HAWAII_3_DAYS_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= 1 DAY BEFORE ARRIVAL =================
    { section: '1 Day Before Arrival', templateId: 284, title: 'GUEST_PARKCITY_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '1 Day Before Arrival', templateId: 280, title: 'GUEST_HAWAII_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Arrival', templateId: 282, title: 'HOMEOWNER_GUEST_PARKCITY_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Arrival', templateId: 286, title: 'HOMEOWNER_GUEST_HAWAII_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Arrival', templateId: 290, title: 'HOMEOWNER_PARKCITY_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day Before Arrival', templateId: 288, title: 'HOMEOWNER_HAWAII_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day Before Arrival', templateId: 851, title: 'GUEST_EXPRESS_CHECK_IN_1_DAY_BEFORE_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= DAY OF ARRIVAL =================
    { section: 'Day Of Arrival', templateId: 772, title: 'GUEST_PARKCITY_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Day Of Arrival', templateId: 774, title: 'GUEST_HAWAII_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Day Of Arrival', templateId: 768, title: 'HOMEOWNER_GUEST_PARKCITY_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Day Of Arrival', templateId: 770, title: 'HOMEOWNER_GUEST_HAWAII_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Day Of Arrival', templateId: 764, title: 'HOMEOWNER_PARKCITY_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Day Of Arrival', templateId: 766, title: 'HOMEOWNER_HAWAII_DAY_OF_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },

    // ================= 1 DAY AFTER ARRIVAL =================
    { section: '1 Day After Arrival', templateId: 270, title: 'GUEST_PARKCITY_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '1 Day After Arrival', templateId: 264, title: 'GUEST_HAWAII_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day After Arrival', templateId: 268, title: 'HOMEOWNER_GUEST_PARKCITY_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day After Arrival', templateId: 266, title: 'HOMEOWNER_GUEST_HAWAII_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '1 Day After Arrival', templateId: 274, title: 'HOMEOWNER_PARKCITY_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day After Arrival', templateId: 272, title: 'HOMEOWNER_HAWAII_1_DAY_AFTER_ARRIVAL', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= 1 DAY BEFORE DEPARTURE =================
    { section: '1 Day Before Departure', templateId: 298, title: 'GUEST_PARKCITY_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Departure', templateId: 292, title: 'GUEST_HAWAII_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Departure', templateId: 296, title: 'HOMEOWNER_GUEST_PARKCITY_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day Before Departure', templateId: 294, title: 'HOMEOWNER_GUEST_HAWAII_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '1 Day Before Departure', templateId: 320, title: 'HOMEOWNER_PARKCITY_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day Before Departure', templateId: 318, title: 'HOMEOWNER_HAWAII_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '1 Day Before Departure', templateId: 854, title: 'GUEST_EXPRESS_CHECK_OUT_1_DAY_BEFORE_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= DAY OF DEPARTURE =================
    { section: 'Day Of Departure', templateId: 326, title: 'GUEST_PARKCITY_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Day Of Departure', templateId: 322, title: 'GUEST_HAWAII_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Day Of Departure', templateId: 324, title: 'HOMEOWNER_GUEST_PARKCITY_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Day Of Departure', templateId: 328, title: 'HOMEOWNER_GUEST_HAWAII_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Day Of Departure', templateId: 278, title: 'HOMEOWNER_PARKCITY_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Day Of Departure', templateId: 276, title: 'HOMEOWNER_HAWAII_DAY_OF_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= 3 DAYS AFTER DEPARTURE =================
    { section: '3 Days After Departure', templateId: 314, title: 'GUEST_PARKCITY_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '3 Days After Departure', templateId: 310, title: 'GUEST_HAWAII_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: '3 Days After Departure', templateId: 312, title: 'HOMEOWNER_GUEST_PARKCITY_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '3 Days After Departure', templateId: 316, title: 'HOMEOWNER_GUEST_HAWAII_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: '3 Days After Departure', templateId: 262, title: 'HOMEOWNER_PARKCITY_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: '3 Days After Departure', templateId: 260, title: 'HOMEOWNER_HAWAII_3_DAYS_AFTER_DEPARTURE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= OTHER TEMPLATES =================

    // ================= RESERVATION =================
    { section: 'Reservation', templateId: 7, title: 'Guest: Day After Arrival Feedback Request', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 21, title: 'Guest Review: public review request template (after receiving review)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 34, title: 'Return Guest Discount', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 36, title: 'OG | PC | 0-DEPART | LEAVE A REVIEW', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 42, title: 'Thank You For Booking Confirmation(SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 45, title: 'Check Out Details (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 48, title: 'Revised Confirmation (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 51, title: 'Rental Car Details (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 54, title: 'Budget Confirmed Rental Car Details (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 57, title: 'Email Invoice KBM Resorts (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 60, title: 'Paid In Full (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 63, title: 'Final Balance Due', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 66, title: 'Email Quote (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 69, title: 'Cancelled Reservation Notification (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 72, title: 'Payment Received HAWAII (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 75, title: 'Admin: New Booking Notification (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 78, title: 'Admin: New Booking Notification - PARK CITY (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 88, title: '1st/2nd Payment Received Park CIty (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 100, title: 'Check in Details (Park City)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 103, title: 'Check In Details (Hawaii)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 106, title: 'Master template', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 115, title: 'Guest Review: public review request template (after receiving review) (Oahu)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 118, title: 'OTA Guest Google Review', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 148, title: 'Utah Email Letterhead', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 149, title: 'Resort Specific New Booking Email to Resort', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 150, title: 'Help template', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 155, title: 'AnswerPoint reservation data email', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 163, title: 'Manual Check In Details Park City', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 165, title: 'new Owner Profile Created Alert', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 166, title: 'Park City Concierge Services', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 184, title: 'Quote - Reservationist Default Message to Guest', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 187, title: 'Guest Confirmation Email', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 195, title: 'Option 2 Hold Email (3nd Email)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 198, title: 'Guest Contract', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 202, title: 'Option 2 Hold Email (1st email)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 205, title: 'Option 2 Hold Email (2nd Email)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 207, title: 'Option 2 Hold Email (4th Email) (1 day after hold expiration)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 210, title: 'Option 2 Hold Email (5th Email) (3 days after hold expiration)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 223, title: 'Credit Card Declined on Final Payment', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 225, title: 'Property Referral Email', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 228, title: 'Thank you for Booking with KBM Resorts - Hawaii', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 779, title: 'Avis Rental Car Details', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 782, title: 'Guest Missing Information (2 weeks prior to check in)', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 813, title: 'Last Minute Booking Email', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 817, title: 'CANCELLED Reservation', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 820, title: 'Date Change Template', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 829, title: 'Owner Date Change Notification', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 832, title: 'Guest / Owner Guest Date Change Notification', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 839, title: 'Day After Arrival Survey Text', formate: 'Email', reservation: 'Pending', msgAudience: 100 },
    { section: 'Reservation', templateId: 840, title: 'GuestReviewFeedback', formate: 'Email', reservation: 'Pending', msgAudience: 100 },

    // ================= CAMPAIGN =================
    { section: 'Campaign', templateId: 231, title: 'Kapalua Bay Villas Spring and Summer Discounts', formate: 'Email', reservation: 'Pending', msgAudience: 200 },
    { section: 'Campaign', templateId: 233, title: 'Kapalua Golf Villas Spring and Summer Offers', formate: 'Email', reservation: 'Pending', msgAudience: 200 },
    { section: 'Campaign', templateId: 236, title: 'Kapalua Ridge Spring and Summer Offers', formate: 'Email', reservation: 'Pending', msgAudience: 200 },
    { section: 'Campaign', templateId: 250, title: 'Park City Return Easter Email', formate: 'Email', reservation: 'Pending', msgAudience: 200 },
    { section: 'Campaign', templateId: 252, title: 'Hawaii Return Guest Easter Email', formate: 'Email', reservation: 'Pending', msgAudience: 200 },
    { section: 'Campaign', templateId: 775, title: 'Villa Easter Emails', formate: 'Email', reservation: 'Pending', msgAudience: 200 },

    // ================= JOBS =================
    { section: 'Jobs', templateId: 10, title: 'Owner: New Booking Notification to Owner', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 13, title: 'Guest Communication Guest Review 2nd attempt MODIFIED TO NOT SEND', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 18, title: 'Guest Communication Guest Review 3rd attempt MODIFIED TO NOT SEND', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 31, title: 'unsubscribe template', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 33, title: 'Guest Review Received DO NOT CHANGE', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 39, title: 'Sharing Review with Homeowner', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 121, title: 'Guest Review Request Day Before Checkout', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 124, title: 'Montage Kapalua Bay (OWN & NPG)', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 152, title: '4th Request for Internal Review', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 162, title: 'New Owner Occupied Status Booking', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 201, title: 'Owner: Sharing 5/5 Review', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 220, title: 'Maintenance Event', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 791, title: 'Owner Portal Change Notification', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 857, title: 'Cancel Rental Car', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 887, title: 'Grocery Text Message (HI)', formate: 'Email', reservation: 'Pending', msgAudience: 400 },
    { section: 'Jobs', templateId: 890, title: 'Arrival Texts HI (OG|OO)', formate: 'Email', reservation: 'Pending', msgAudience: 400 },

    // ================= OWNER PROFILE =================
    { section: 'Owner Profile', templateId: 85, title: 'Owner Arrivals (SL)', formate: 'Email', reservation: 'Pending', msgAudience: 500 },
    { section: 'Owner Profile', templateId: 130, title: 'Owner Booking Confirmation', formate: 'Email', reservation: 'Pending', msgAudience: 500 },
    { section: 'Owner Profile', templateId: 139, title: 'Owner Confirmation 14 Days Before Arrival', formate: 'Email', reservation: 'Pending', msgAudience: 500 },
    { section: 'Owner Profile', templateId: 142, title: 'Owner Cancellation Confirmation', formate: 'Email', reservation: 'Pending', msgAudience: 500 },

    // ================= REALTOR =================
    { section: 'Realtor', templateId: 254, title: 'Realtor Profile Test', formate: 'Email', reservation: 'Pending', msgAudience: 510 },

    // ================= TASK =================
    { section: 'Task', templateId: 37, title: 'Task Status change template', formate: 'Email', reservation: 'Pending', msgAudience: 600 },
    { section: 'Task', templateId: 94, title: 'Task Status update Request', formate: 'Email', reservation: 'Pending', msgAudience: 600 },
    { section: 'Task', templateId: 96, title: 'Task Update Submitted', formate: 'Email', reservation: 'Pending', msgAudience: 600 },
    { section: 'Task', templateId: 99, title: 'Task Assigned to template', formate: 'Email', reservation: 'Pending', msgAudience: 600 },

    // ================= BIZDEV =================
    { section: 'Bizdev', templateId: 5, title: 'BizDev: Proforma Reply Email', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 797, title: 'Bizdev Template 1 - Information Regarding Kapalua Bay Villa XXXX', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 800, title: 'Bizdev Template 2 - Increased Revenue Through Group & Bundle Bookings', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 803, title: 'Bizdev Template 3 - Highlighting Unique Property Features', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 809, title: 'Proforma Details', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 812, title: "L'Occitane Owner Email", formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 815, title: 'Bizdev Template 4 - Individual Outreach', formate: 'Email', reservation: 'Pending', msgAudience: 700 },
    { section: 'Bizdev', templateId: 893, title: 'Real Estate Referral Program Hawaii', formate: 'Email', reservation: 'Pending', msgAudience: 700 },

    // ================= GUEST COMMUNICATION =================
    { section: 'Guest Communication', templateId: 108, title: 'Housekeeper Arrival/Departure (check in ready)', formate: 'Email', reservation: 'Pending', msgAudience: 1600 },
    { section: 'Guest Communication', templateId: 127, title: 'Owner Guest Portal', formate: 'Email', reservation: 'Pending', msgAudience: 1600 },
    { section: 'Guest Communication', templateId: 133, title: 'Owner Guest Confirmation', formate: 'Email', reservation: 'Pending', msgAudience: 1600 },
    { section: 'Guest Communication', templateId: 158, title: 'Refund Notification', formate: 'Email', reservation: 'Pending', msgAudience: 1600 },
    { section: 'Guest Communication', templateId: 879, title: 'Yelp Review Request to Good reviewers', formate: 'Email', reservation: 'Pending', msgAudience: 1600 },

    // ================= OTHER =================
    { section: 'Other', templateId: 3, title: 'Default: Sample', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 15, title: 'Default: Company Letterhead: Guest', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 19, title: 'BizDev: Owner (Vacasa Layoffs)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 24, title: 'Guest Communication Day of check in MODIFIED TO NOT SEND', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 27, title: 'Guest Communication Day after check in MODIFIED TO NOT SEND', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 30, title: 'Guest Communication Day before check out MODIFIED TO NOT SEND', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 81, title: 'Admin: Res Notification to Owner Services (SL)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 91, title: 'Utah Bookings Notification (SL)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 102, title: 'Old Review Links', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 109, title: 'Guest Review: public review request template (after receiving review) (Park City)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 112, title: 'Guest Review: public review request template (after receiving review) (Big Island)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 136, title: 'Park City Email Header', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 145, title: 'Hawaii Email Letterhead', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 159, title: 'Last Minute Booking', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 168, title: 'Template for all variables', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 169, title: 'WELCOME GUEST LETTER - General', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 172, title: 'WELCOME GUEST LETTER - Birthday', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 175, title: 'WELCOME GUEST LETTER - Anniversary', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 178, title: 'WELCOME GUEST LETTER - Graduation', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 181, title: 'WELCOME GUEST LETTER - Honeymoon', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 199, title: 'Admin: New Hold Notification', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 213, title: 'Option 2 Hold Email (6th Email) (7 days after hold expiration)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 216, title: 'Option 2 Hold Email (7th Email) (2 weeks after hold expiration)', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 238, title: 'Book Again Text!', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 777, title: 'New Car Reservation Request', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 785, title: 'Maintenance Reservation Created - VIP Check', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 788, title: 'Bizdev Template', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 794, title: 'Bizdev Portal Owner Submission', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 806, title: 'Test', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 823, title: 'Resort Specific Date Change Notification to Resort', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 826, title: 'Resort Specific Cancellation Notification to Resort', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 836, title: 'Fall Park City Marketing Email 2025', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 860, title: 'Guest Survey Primary Text', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 863, title: 'Guest Survey - Reply 1', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 866, title: 'Guest Survey- Reply 2', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 868, title: 'Upsell Text Message', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 871, title: 'OWNER STATEMENTS', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 874, title: 'Concierge Public Website Intake Form', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 876, title: 'Default: Company Letterhead: Homeowner', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 881, title: 'Share Property Email - Park City Properties', formate: 'Email', reservation: 'Pending', msgAudience: null },
    { section: 'Other', templateId: 884, title: 'Share Property Email - Hawaii', formate: 'Email', reservation: 'Pending', msgAudience: null },
  ];

  ngOnInit(): void {
    // When this component is embedded on the order/reservation page with a specific
    // msgTopicId (reservation scope), disable the inbox-conversation grouping view.
    // The inboxConversion query only surfaces the last *inbound* message per conversation,
    // which hides all automated outbound messages (door codes, Wi-Fi, parking, review
    // requests) sent by GuestCommunicationJob / SmsDripDispatcher.
    // With showUnread=false the component uses the flat filter path that respects the
    // topicId filter and returns every message row for this reservation in order.
    if (this.msgTopicId) {
      this.showUnread = false;
    }

    this.buildReservationOptions();
    this.setDefaultReservation();
    this.startNotificationStream();
    this.loadAllTags();

    this.starSubject.pipe(
      debounceTime(800),
      takeUntil(this.destroy$)
    ).subscribe(() => this.flushStarChanges());

    try {
      const topicIdFromQuery = this.route.snapshot.queryParams['topicId'];
      if (topicIdFromQuery) {
        this.msgTopicId = Number(topicIdFromQuery);
      }
      const topicFromQuery = this.route.snapshot.queryParams['topic'];
      if (topicFromQuery) {
        this.msgTopic = Number(topicFromQuery);
      }

      this.route.paramMap.subscribe(params => {
        const contextId = params.get('contextId');
        const subContextId = params.get('subContextId');
        const status = params.get('status');
        if (contextId) {
          this.msgContextIds = [Number(contextId)];
          this.msgContext = Number(contextId);
        }
        else {
          this.msgContextIds = [];
        }
        if (subContextId) {
          this.msgSubContextIds = [Number(subContextId)];
        }
        else {
          this.msgSubContextIds = [];
        }
        if (status) {
          this.selectedmailbox = status;
          this.showUnread = this.isConversationViewMailbox(this.selectedmailbox);
        }

        // Initialize msgOriginIds if not set
        if (!this.msgOriginIds) {
          this.msgOriginIds = [];
        }

        this.onContextChange(this.msgContextIds);
        console.log('Changed Context:', contextId);
      });

      this.route.queryParamMap.subscribe(q => {
        const statusFromQuery = q.get('status');
        if (statusFromQuery) {
          this.selectedmailbox = statusFromQuery;
          this.showUnread = this.isConversationViewMailbox(this.selectedmailbox);
        }
        const statementId = q.get('statementId');
        statementId ? this.statementIdFromQuery = statementId : '';
        const ownerProfileId = q.get('ownerProfileId');
        ownerProfileId ? this.ownerProfileIdFromQuery = ownerProfileId : '';
        const propertyProfileId = q.get('propertyProfileId');
        propertyProfileId ? this.propertyProfileIdFromQuery = propertyProfileId : '';
        const topicId = q.get('topicId');
        topicId ? this.msgTopicId = Number(topicId) : null;
        const topic = q.get('topic');
        topic ? this.msgTopic = Number(topic) : null;
      });

      //If context is 9 (BizDev), fetch only BizDev templates
      if (this.msgContext == 9) {
        this.templateMsgAudience = 700;
      }
      //If context is 7 (Reservation), fetch only Reservation templates
      else if (this.msgContext == 7) {
        this.templateMsgAudience = 100;
      }

      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: 'createDate', order: 1 });

      this.items = [
        {
          label: 'Assign Task',
          icon: 'pi pi-fw pi-plus',
          command: (event) => this.openCreatTask(this.selectedNode.data)
        },
        {
          separator: true
        },
        {
          label: 'Archive',
          icon: 'pi pi-fw pi-download',
          command: (event) => this.archiveMsg(this.selectedNode.data)
        }
      ];

    }
    catch (error) {
      console.log('Error: ' + error);
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.notificationStreamController?.abort();
  }

  buildReservationOptions() {
    this.reservationOptions = this.order?.reservations?.length > 0 ? this.order.reservations.map(res => ({
      label: res.reservationId + ' - ' + res.reservationStatus,
      value: res.reservationId
    })) : [];
  }

  setDefaultReservation() {
    if (this.order?.reservations && this.order?.reservations?.length > 0) {

      const defaultReservationId = this.order.reservations[0].reservationId;

      this.tableData1 = this.tableData1.map(row => ({
        ...row,
        selectedReservationId: defaultReservationId
      }));
    }
  }


  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + event.inboxId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      if (!this.isSilentRefresh) this.formLoading = true;
      this.lazyLoadEvent = event;
      if (this.msgStartDate) {
        event.filters['msgStartDate'] = {
          value: this.datePipe.transform(this.msgStartDate, 'yyyy-MM-dd'),
          matchMode: 'gte'
        };
      }
      if (this.msgEndDate) {
        event.filters['msgEndDate'] = {
          value: this.datePipe.transform(this.msgEndDate, 'yyyy-MM-dd'),
          matchMode: 'lte'
        };
      }
      // When scoped to a specific reservation/topic (msgTopicId is set), show ALL
      // messages for that reservation regardless of direction (inbound or outbound).
      // This includes automated pre-arrival SMS (door codes, Wi-Fi, parking) sent by
      // GuestCommunicationJob which are stored as STATUS_SENT / msgFolder=1 — previously
      // invisible because the default inbox view only queried STATUS_RECEIVED / msgFolder=0.
      if (this.msgTopicId) {
        delete event.filters['msgFolder'];
        delete event.filters['msgPriority'];
        delete event.filters['status'];
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'createDate', order: 1 });
      }
      else if ('0' === this.selectedmailbox) {
        event.filters['msgFolder'] = {};
        event.filters['msgFolder'].matchMode = 'in';
        event.filters['msgFolder'].value = 2;
        delete event.filters['msgPriority'];
        delete event.filters['tagId'];
      }
      else if ('2' === this.selectedmailbox) { // Sent
        event.filters['msgFolder'] = {};
        event.filters['msgFolder'].matchMode = 'in';
        event.filters['msgFolder'].value = 1;
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'sentDate', order: -1 });
        delete event.filters['msgPriority'];
        delete event.filters['tagId'];
      }
      else if ('starred' === this.selectedmailbox) {
        event.filters['msgFolder'] = {};
        event.filters['msgFolder'].matchMode = 'in';
        event.filters['msgFolder'].value = 0;
        event.filters['msgPriority'] = {};
        event.filters['msgPriority'].matchMode = 'in';
        event.filters['msgPriority'].value = 1;
        delete event.filters['tagId'];
        if (!this.orderId) {
          event.multiSortMeta = [];
          event.multiSortMeta.push({ field: 'receivedDate', order: -1 });
        }
      }
      else if ('tag' === this.selectedmailbox) {
        delete event.filters['msgFolder'];
        delete event.filters['msgPriority'];
        event.filters['tagId'] = { value: this.selectedTagIds, matchMode: 'in' };
        if (!this.orderId) {
          event.multiSortMeta = [];
          event.multiSortMeta.push({ field: 'receivedDate', order: -1 });
        }
      }
      else {
        // default Inbox
        event.filters['msgFolder'] = {};
        event.filters['msgFolder'].matchMode = 'in';
        event.filters['msgFolder'].value = 0;
        delete event.filters['msgPriority'];
        delete event.filters['tagId'];
        if (!this.orderId) {
          event.multiSortMeta = [];
          event.multiSortMeta.push({ field: 'receivedDate', order: -1 });
        }
      }

      // if(!event.filters['msgContext'])
      // {
      //    event.filters['msgContext'] = {};
      //    event.filters['msgContext'].matchMode = 'in';
      //    event.filters['msgContext'].value = [7, 8];
      // }
      if (this.msgContext) {
        event.filters['msgContext'] = {};
        event.filters['msgContext'].matchMode = 'in';
        event.filters['msgContext'].value = [this.msgContext];
      }

      if (this.msgSubContext) {
        event.filters['msgSubContext'] = {};
        event.filters['msgSubContext'].matchMode = 'in';
        event.filters['msgSubContext'].value = [this.msgSubContext];
      }

      // When scoped to a specific reservation, status filtering was already cleared above.
      // Only apply status/mailbox filter for the standalone inbox page (no msgTopicId).
      if (!this.msgTopicId) {
        if ('0' === this.selectedmailbox || 'starred' === this.selectedmailbox || 'tag' === this.selectedmailbox) {
          event.filters['status'] = {};
          event.filters['status'].value = '';
          event.filters['status'].matchMode = 'in';
        }
        else {
          event.filters['status'] = {};
          event.filters['status'].value = this.selectedmailbox;
          event.filters['status'].matchMode = 'in';
        }
      }

      // Apply topicId filter when a specific reservation/topic is scoped.
      // The msgTopicId block above already cleared status/msgFolder, so we always
      // apply the topicId filter here when msgTopicId is set.
      if (this.msgTopicId) {
        event.filters['topicId'] = {};
        event.filters['topicId'].value = this.msgTopicId;
        event.filters['topicId'].matchMode = 'in';
      }

      if (this.orderId) {
        event.filters['orderId'] = {};
        event.filters['orderId'].value = this.orderId;
        event.filters['orderId'].matchMode = 'in';
      }

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      /*
      *
      * Default Sort
      */
      // https://stackoverflow.com/questions/679915/how-do-i-inbox-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'createDate', order: -1 });
      }
      if (this.defaultImapConfId) {
        let emailFilter = { 'ImapConfigurationVO.imapConfigurationId': { 'value': this.defaultImapConfId, 'matchMode': 'in' } };
        Object.assign(event.filters, emailFilter);
      }

      //Temporory
      if (this.ownerEmail) {
        let emailFilter = { 'senderEmail': { 'value': this.ownerEmail, 'matchMode': 'in' } };
        Object.assign(event.filters, emailFilter);
      }
      if (this.ownerMobile) {
        let mobileFilter = { 'senderMobileNum': { 'value': this.ownerMobile, 'matchMode': 'in' } };
        Object.assign(event.filters, mobileFilter);
      }
      if (this.ownerProfileIdFromQuery) {
        event.filters['ownerProfileId'] = { value: this.ownerProfileIdFromQuery, matchMode: 'in' };
      }
      if (this.propertyProfileIdFromQuery) {
        event.filters['propertyProfileId'] = { value: this.propertyProfileIdFromQuery, matchMode: 'in' };
      }
      //12-30-2025 Divy - If filter is applied then show every msgs into single result. No filtering by status and folder
      if (this.searchKeyWork) {
        delete event.filters['status'];
        delete event.filters['msgFolder'];
        event.multiSortMeta = [];
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.inboxService.findByFilterForTopic(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters,
        this.msgTopic, this.searchKeyWork, this.searchKeyFilter,
        this.showUnread ? 'inboxConversion' : null).pipe(first()).subscribe(

          (res: any) => {
            this.datasource = res.data.msgs; // must be the array, not the wrapper object
            this.recordTotal = res.page.recordTotal;
            const newInboxs: any[] = [];
            this.inbox = res.data.msgs;
            this.allInboxes = res.data.msgs;
            if (!this.isSilentRefresh) this.selectedMailEntry = null;
            for (let i = 0; i < res.data.msgs.length; i++) {
              let entry = res.data.msgs[i];
              if (!res.data.msgs[i].emailHtml && res.data.msgs[i].emailText) {
                res.data.msgs[i].emailHtml = res.data.msgs[i].emailText;
              }
              entry.starred = (entry.msgPriority === 1);

              let nameInitial: any = '';
              try {
                if (entry?.imapConfigurationAPI?.name) {
                  nameInitial = Array.from(entry?.imapConfigurationAPI?.name)[0];
                  nameInitial = nameInitial.toUpperCase();
                } else {
                  nameInitial = Array.from(entry?.msgRecipientAPIList[0]?.email)[0];
                }
                entry.nameInitial = nameInitial;
                entry.receiverEmail = entry?.msgRecipientAPIList[0]?.email;
              } catch (e) {

              }
              try {
                if (entry?.status === 2) {
                  entry.dateCreation = entry.sentDate;
                }
                if (entry?.status === 3) {
                  entry.dateCreation = entry.receivedDate;
                }
                if (!entry.dateCreation) {
                  entry.dateCreation = entry.createDate;
                }
              } catch (e) {

              }

              try {
                let opened = 0, clicked = 0, bounced = 0, deferred = 0;
                let earliestOpenedDate: Date | null = null;
                let earliestDeliveredDate: Date | null = null;
                for (const r of entry.msgRecipientAPIList || []) {
                  opened += r.openedCount ?? 0;
                  clicked += r.clickedCount ?? 0;
                  bounced += r.bouncedCount ?? 0;
                  deferred += r.deferredCount ?? 0;
                  if (r.openedDate) {
                    const oDate = new Date(r.openedDate);
                    if (!earliestOpenedDate || oDate < earliestOpenedDate) {
                      earliestOpenedDate = oDate;
                    }
                  }
                  if (r.deliveredDate) {
                    const dDate = new Date(r.deliveredDate);
                    if (!earliestDeliveredDate || dDate < earliestDeliveredDate) {
                      earliestDeliveredDate = dDate;
                    }
                  }
                }
                entry.openedCount = opened;
                entry.clickedCount = clicked;
                entry.bouncedCount = bounced;
                entry.deferredCount = deferred;
                entry.openedDate = earliestOpenedDate;
                entry.deliveredDate = earliestDeliveredDate;
              } catch (e) {
                entry.openedCount = 0;
                entry.bouncedCount = 0;
                entry.clickedCount = 0;
                entry.deferredCount = 0;
                entry.openedDate = null;
                entry.deliveredDate = null;
              }

              let node = {
                data: entry,
                leaf: false
              };
              newInboxs.push(node);
            }
            this.inboxs = [...newInboxs];
            const loadedMsgIds = newInboxs.map(n => n.data?.msgId).filter(Boolean);
            this.loadTagsForMsgs(loadedMsgIds);
            if (this.pendingNotificationMsgId) {
              const matchingNode = this.inboxs.find(node => node.data?.msgId === this.pendingNotificationMsgId);
              this.openSelectedMail(matchingNode ? matchingNode.data : { msgId: this.pendingNotificationMsgId });
              this.pendingNotificationMsgId = null;
            } else if (this.isSilentRefresh) {
              if (this.selectedRow) {
                const currentMsgId = (this.selectedRow as any).msgId;
                const match = this.inboxs.find(node => node.data?.msgId === currentMsgId);
                if (match) this.selectedRow = match.data;
              }
            }
            console.log(JSON.stringify(res.page));
            this.loading = false;
            if (!this.isSilentRefresh) this.scrollMessageListToTop();
          },
          (err: any) => {
            this.loading = false;
            this.formLoading = false;
            this.isSilentRefresh = false;
            this.inboxs = [];
            console.log('reviews list error!: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; this.isSilentRefresh = false; }
        );

    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
      this.loading = false;
    }
  }

  onContextChange(selectedContextIds: number[]) {
    selectedContextIds = selectedContextIds || [];
    this.msgContextIds = [...selectedContextIds];
    this.msgContext = selectedContextIds.length === 1 ? selectedContextIds[0] : null;

    // Flatten all matching subcontexts from selected contexts
    this.msgSubContextsFiltered = selectedContextIds
      .flatMap(contextId => this.msgSubContextMap[contextId] || []);

    // Clear selected subcontext IDs if no longer valid
    this.msgSubContextIds = this.msgSubContextIds?.filter(
      id => this.msgSubContextsFiltered.some(sub => sub.value === id)
    ) || [];

    if (selectedContextIds.length === 0) {
      this.msgSubContext = null;
    }

    this.pt?.filter(selectedContextIds.length > 0 ? selectedContextIds : null, 'msgContext', 'in');
    this.pt?.filter(this.msgSubContextIds.length > 0 ? this.msgSubContextIds : null, 'msgSubContext', 'in');
    console.log(this.msgContextIds);
  }

  onMessageArchived(archivedMessage: any) {
    const index = this.inboxs.findIndex(m => m?.data?.msgId === archivedMessage.msgId);

    if (index !== -1) {
      // Remove the archived message
      const updatedList = [...this.inboxs];
      updatedList.splice(index, 1);
      this.inboxs = updatedList; // trigger change detection

      if (this.inboxs.length > 0) {
        // If there's a next item, select it; else go back one
        let nextIndex = index;
        // If last message was removed, step back one
        if (nextIndex >= this.inboxs.length) {
          nextIndex = this.inboxs.length - 1;
        }
        const nextMsg = this.inboxs[nextIndex]?.data;
        if (nextMsg) {
          this.openSelectedMail(nextMsg); // triggers UI load
        } else {
          this.selectedMailEntry = null;
        }
      } else {
        this.selectedMailEntry = null; // list empty
      }
      this.messageService.add({
        severity: 'success',
        summary: 'Archived',
        detail: "Archived successfully",
      });
    }
  }


  onKeywordClicked(value: string): void {
    this.searchKeyWork = value;
    this.searchByKeywork({ target: { value } } as any); // simulate input event if needed
  }

  getMsgContextName(value: number): string {
    const context = this.msgContexts.find((item: any) => item.value === value);
    return context ? context.name : '';
  }

  getMsgSubContextName(value: number): string {
    for (const contextId in this.msgSubContextMap) {
      const match = this.msgSubContextMap[contextId].find(sc => sc.value === value);
      if (match) {
        return match.name;
      }
    }
    return '';
  }

  getMsgOriginName(value: number): string {
    const origin = this.msgOrigin.find((item: any) => item.value === value);
    return origin ? origin.name : '';
  }

  getMsgRole(value: number): string {
    const origin = this.msgRoles.find((item: any) => item.value === value);
    return origin ? origin.name : '';
  }

  openReservation(reservationId: number, event: any) {
    event.stopPropagation();
    this.openingReservation[reservationId] = true;
    this.inboxService.getOrderIdByReservationId(reservationId).pipe(first()).subscribe(
      (res: any) => {
        console.log('Order ID: ' + JSON.stringify(res));
        this.orderId = res.data.orderId;
        window.open(`https://admin.kbmhawaii.com/order/${this.orderId}`, '_blank');
        this.openingReservation[reservationId] = false;
      },
      (err: any) => {
        console.log('Error fetching order ID: ' + JSON.stringify(err));
        this.openingReservation[reservationId] = false;
      }
    );
  }


  onNodeExpand1(event: any) {
    const node = event.node;
    const childInboxes = [];
    this.inboxService.findChildMails(node.data.msgId).pipe(first()).subscribe(
      (res: any) => {
        this.childInboxesData = res.data.msgs;
        for (let i = 0; i < this.childInboxesData.length; i++) {
          let entry = res.data.msgs[i];
          let imapConfId = '', imapConfName = '';
          if (res.data.msgs[i].imapConfigurationAPI) {
            imapConfId = res.data.msgs[i].imapConfigurationAPI.imapConfigurationId;
            imapConfName = this.childInboxesData[i].imapConfigurationAPI.name;
          }
          let nameInitial: any = '';
          if (entry?.imapConfigurationAPI?.name) {
            nameInitial = Array.from(entry?.imapConfigurationAPI?.name)[0];
            nameInitial = nameInitial.toUpperCase();
          }
          let node = {
            data: {
              msgId: this.childInboxesData[i].msgId,
              inboxName: imapConfName,
              status: this.getStatusName(this.childInboxesData[i]),
              senderName: this.childInboxesData[i].senderName,
              senderEmail: this.childInboxesData[i].senderEmail,
              subject: this.childInboxesData[i].subject,
              receivedDate: this.datePipe.transform(this.childInboxesData[i].receivedDate, 'MMM d, y, h:mm:ss a'),
              emailHtml: this.childInboxesData[i].emailHtml,
              imapConfigId: imapConfId,
              taskAPIList: this.childInboxesData[i].taskAPIList,
              ischild: true,
              nameInitial: nameInitial
            },
          };
          childInboxes.push(node);
        }
        node.children = childInboxes;
        this.inboxs = [...this.inboxs];
      },
      (err: any) => {
        console.log('reviews list error!: ' + JSON.stringify(err));
        this.alertService.error(err);
      },
      () => { this.loading = false; }
    );
  }
  onNodeExpand(event: any) {
    const node = event.node;
    let subtaskList = [];
    let msges = node?.data?.children;
    for (let i = 0; i < msges.length; i++) {
      /* if ( this.currentUser.userId === tasks[i]?.assignedTo?.userId || this.currentUser.userId === tasks[i]?.createdBy?.userId ||
         this.currentUser.userId === tasks[i]?.ownedBy?.userId ) */
      msges[i].ischild = true;
      let entry = {
        'data': msges[i],
        leaf: false,
      };
      subtaskList.push(entry);

    }
    node.children = subtaskList;
    this.inboxs = [...this.inboxs];
  }
  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log('onRowSelect: ' + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() { }


  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(inbox: Inbox) {
    try {
      this.formLoading = true;
      this.inboxService.update(inbox)
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
            this.inboxs.map((inbox, i) => {
              if (inbox.msgId === res.data.msg.msgId) {
                this.inboxs[i] = res.data.inbox;
              }
            });
            // this.alertService.success(res, true);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
          },
          (err: any) => {
            console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(inbox: any) {
    try {
      // stop here if form is invalid
      console.log('Delete Submitted: ' + JSON.stringify(inbox));

      this.formLoading = true;
      this.inboxService.delete(inbox.inboxId)
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
            this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
            this.recordTotal = this.inboxs.length;
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Inbox ' + inbox.inboxId + ' Deleted', life: 3000 });
          },
          (err: any) => {
            console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Inbox ' + inbox.inboxId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
  refreshMails() {
    this.isSilentRefresh = false; // show spinner + reset selection on manual refresh
    this.loadLazy(this.lazyLoadEvent);
  }
  /*********
   * Add New Button for sending both mail and sms
   *
   */
  onOpenFormAddMailAndSMS() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    dialogConfig.width = '90vw';
    dialogConfig.height = '90vh';
    dialogConfig.maxWidth = '1400px';
    dialogConfig.maxHeight = '90vh';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'New Mail',
      msgTopicId: [this.msgTopicId],
      msgTopic: [this.msgTopic],
      mobilePhone: this.mobilePhone,
      reservations: this.reservations,
      msgTemplateData: this.msgTemplateData,
      templateMsgAudience: this.templateMsgAudience,
      msgContextId: 7 // Reservations
    };

    console.log('CONTEXXXXXXX');
    console.log(this.msgTopic);
    console.log(this.msgTopicId);
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxMailSMsComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
  }

  onOpenFormAddForSMS() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'New SMS',
      msgTopicId: this.msgTopicId,
      msgTopic: this.msgTopic
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxSmsComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
  }

  getRecipientTooltip(rowData: any): string {
    if (!rowData?.msgRecipientAPIList || rowData.msgRecipientAPIList.length <= 1) {
      return '';
    }
    // Collect all emails except the first one
    return rowData.msgRecipientAPIList
      .slice(1)
      .map(r => r.email)
      .join(', ');
  }

  // clearSearch() {
  //   this.searchKeyWork = '';
  //   this.searchByKeywork(null); // reset search results if needed
  // }


  /*********
    * Edit Button
    *
    */
  onOpenFormEdit(inbox: Inbox) {

    const dialogConfig = new MatDialogConfig();
    // settings
    dialogConfig.width = '100%';
    dialogConfig.height = '100%';
    dialogConfig.maxWidth = '1600px';
    dialogConfig.maxHeight = '800px';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      inbox: inbox,
      title: 'View Inbox Mail'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.updateInboxCB(data);
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);

      });

    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.deleteInboxCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }

  openSelectedMail(inbox: any) {
    this.selectedRow = inbox; // Set the selected row here
    this.selectedMailEntry = null;
    this.mailPaneLoading = true; // Start loader
    this.changeDetector.detectChanges(); // every time mail entry is changed component should be reloaded this is way to tell ng prime that component needs to reloaded

    if (inbox) {
      this.msgService.findById(inbox?.msgId).subscribe(
        (res: any) => {
          console.log('send message, SUCCESS: ' + JSON.stringify(res));
          this.msg = res.data.msg;
          this.selectedMailEntry = res.data.msg;
          this.selectedMailEntry.reservationAPI = inbox.reservationAPI;
          this.mailPaneLoading = false; // Stop loader
        },
        (err: any) => {
          console.log('msg-add FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
          this.mailPaneLoading = false; // Stop loader even on error
        },
      );
    }
  }

  /**
     *
     * Dialog from Form Callbacks
     * To edit the list show add/edit/delete in real time from the popup form
     *
     */
  addInboxCB(inbox: Inbox) {
    console.log('Adding Inbox: ' + JSON.stringify(inbox));
    // if we don't have a inboxs array yet...
    if (!this.inboxs) {
      this.inboxs = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.inboxs.unshift(inbox);

    // no idea what this is but it is required to update the array
    this.inboxs = [...this.inboxs];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Added', life: 3000 });
  }

  updateInboxCB(inbox: Inbox) {
    console.log('Updating Inbox: ' + JSON.stringify(inbox));
    let itemIndex = this.inboxs.findIndex((item: any) => item.inboxId === inbox.msgId);
    this.inboxs[itemIndex] = inbox;

    // no idea what this is but it is required to update the array
    this.inboxs = [...this.inboxs];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Updated', life: 3000 });
  }

  deleteInboxCB(inbox: Inbox) {
    console.log('Removing Inbox: ' + inbox);
    this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
    this.recordTotal = this.inboxs.length;

    // no idea what this is but it is required to update the array
    this.inboxs = [...this.inboxs];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Deleted', life: 3000 });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
    this.scrollMessageListToTop();
  }
  prev() {
    this.first = this.first - this.rows;
    this.scrollMessageListToTop();
  }
  reset() {
    this.first = 0;
    this.scrollMessageListToTop();
  }

  scrollMessageListToTop(): void {
    if (this.messageListWrapper && this.messageListWrapper.nativeElement) {
      setTimeout(() => {
        this.messageListWrapper.nativeElement.scrollTop = 0;
      }, 0);
    }
  }
  isLastPage(): boolean {
    if (!this.recordTotal || !this.lazyLoadEvent) return true;
    const currentFirst = this.lazyLoadEvent.first || this.first || 0;
    const currentRows = this.lazyLoadEvent.rows || this.rows || 50;
    return (currentFirst + currentRows) >= this.recordTotal;
  }
  isFirstPage(): boolean {
    if (!this.lazyLoadEvent) return this.first === 0;
    return (this.lazyLoadEvent.first || this.first || 0) === 0;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(inbox: any) {
    if (inbox?.status) {
      const status = this.statuses.find((e: any) => e.value == inbox.status);
      return status.name;
    }
    else {
      return '';
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }

  onShowUnreadChange() {
    this.loadLazy(this.lazyLoadEvent);
  }

  loadMailBox(event: any) {
    this.selectedMails = [];  // Clear selected emails
    this.selectAllCheckbox = false; // Also reset "Select All" checkbox if needed
    this.inboxs.forEach(msg => msg.checkboxFlag = false);
    this.selectedRow = null;
    this.selectedMailEntry = null;
    this.mailPaneLoading = false;
    this.leftSidebarWidth = 20;
    this.selectedTagIds = [];
    this.selectedTag = null;
    if (this.lazyLoadEvent?.filters) {
      delete this.lazyLoadEvent.filters['tagId'];
    }
    this.showUnread = event === '3';
    this.loadLazy(this.lazyLoadEvent);
  }

  private isConversationViewMailbox(mailbox: string): boolean {
    return mailbox === '3' || mailbox === 'tag';
  }

  private loadAllTags(): void {
    const filters: any = { tagType: { value: 4, matchMode: 'in' } };
    const context = Number(this.msgContext);
    if (context === 7) {
      filters.tagGroupCategory = { value: 'Guest Communication', matchMode: 'in' };
    } else if (context === 8) {
      filters.tagGroupCategory = { value: 'Owner Communication', matchMode: 'in' };
    }

    this.tagService.findByFilter(
      0, 1000, 'name', 1, null, null,
      filters
    ).pipe(first()).subscribe(
      (res: any) => { this.allTags = res?.data?.tags ?? []; },
      (err: any) => console.error('Failed to load tags:', err)
    );
  }

  selectTag(tag: any): void {
    const alreadySelected =
      this.selectedmailbox === 'tag' && this.selectedTagIds.length === 1 && this.selectedTagIds[0] === tag.tagId;

    if (alreadySelected) {
      this.selectedTagIds = [];
      this.selectedTag = null;
      this.selectedmailbox = '3';
      this.showUnread = true;
    } else {
      this.selectedTagIds = [tag.tagId];
      this.selectedTag = tag;
      this.selectedmailbox = 'tag';
      this.showUnread = true;
    }
    this.selectedMails = [];
    this.selectAllCheckbox = false;
    this.selectedRow = null;
    this.selectedMailEntry = null;
    this.mailPaneLoading = false;
    this.loadLazy(this.lazyLoadEvent);
  }

  onMobileTagsChange(tagIds: number[]): void {
    this.selectedTagIds = tagIds ?? [];
    if (this.selectedTagIds.length > 0) {
      this.selectedmailbox = 'tag';
      this.showUnread = true;
    } else {
      this.selectedmailbox = '3';
      this.showUnread = true;
    }
    this.selectedMails = [];
    this.selectAllCheckbox = false;
    this.selectedRow = null;
    this.selectedMailEntry = null;
    this.mailPaneLoading = false;
    this.loadLazy(this.lazyLoadEvent);
  }

  openAddTagDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '500px';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.data = { title: 'Add Tag' };

    const dialogRef = this.dialog.open(TagComponent, dialogConfig);
    dialogRef.componentInstance.doAdd.subscribe((tag: any) => {
      this.allTags = [...this.allTags, tag];
      dialogRef.close();
    });
  }

  private openCreatTask(selectedNode: any) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let custTaskApi = { name: selectedNode.subject };
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
      purpose: 'createmailtask',
      taskApi: custTaskApi,
      msg: selectedNode as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg = new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg = new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
  }


  toggleStar(rowData: any): void {
    rowData.starred = !rowData.starred;
    this.pendingStarChanges.set(rowData.msgId, rowData.starred);
    this.starSubject.next();
  }

  private flushStarChanges(): void {
    if (this.pendingStarChanges.size === 0) return;

    const starredIds: number[] = [];
    const unstarredIds: number[] = [];

    this.pendingStarChanges.forEach((starred, msgId) => {
      if (starred) starredIds.push(msgId);
      else unstarredIds.push(msgId);
    });
    this.pendingStarChanges.clear();

    if (starredIds.length > 0) {
      this.msgService.updateMsgPriority(starredIds, 1).subscribe(
        () => {},
        (err: any) => this.alertService.error(err)
      );
    }
    if (unstarredIds.length > 0) {
      this.msgService.updateMsgPriority(unstarredIds, 0).subscribe(
        () => {},
        (err: any) => this.alertService.error(err)
      );
    }
  }


  onMessageTagsUpdated(payload: { msgId: number; tags: any[] }): void {
    if (!payload?.msgId) return;
    const tags = Array.isArray(payload.tags) ? [...payload.tags] : [];
    this.msgTagsMap = { ...this.msgTagsMap, [payload.msgId]: tags };
    this.inboxs = [...this.inboxs];
  }

  private loadTagsForMsgs(msgIds: number[]): void {
    if (!msgIds || msgIds.length === 0) return;
    this.msgTagsMap = {};
    this.msgService.getTagsBySource(120, msgIds).subscribe(
      (res: any) => {
        const tagsBySource = res?.data?.tagsBySource ?? res?.tagsBySource;
        if (tagsBySource) {
          const newMap: { [msgId: number]: any[] } = {};
          tagsBySource.forEach((item: any) => {
            newMap[item.sourceId] = item.tags || [];
          });
          this.msgTagsMap = newMap;
          this.inboxs = [...this.inboxs];
        }
      },
      (err: any) => console.error('Failed to load tags:', err)
    );
  }

  private archiveMsg(selectedNode: TreeNode) {
    try {
      let msg = new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
          // this.loadLazy(this.lazyLoadEvent);
          this.onMessageArchived(msg);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  archiveSelected() {
    const msgIds: number[] = this.selectedMails
      .map((m: any) => m?.data?.msgId ?? m?.msgId)
      .filter((id): id is number => !!id);

    if (msgIds.length === 0 || this.isBulkArchiving) return;
    this.isBulkArchiving = true;

    this.msgService.updateMsgsFolder(msgIds, 2).subscribe(
      (res: any) => {
        this.isBulkArchiving = false;
        this.messageService.add({ severity: 'success', summary: 'Archived', detail: res.message });
        this.selectedMails = [];
        this.selectAllCheckbox = false;
        this.inboxs.forEach(x => { if (x?.data) x.data.checkboxFlag = false; });
        this.selectedRow = null;
        this.selectedMailEntry = null;
        this.mailPaneLoading = false;
        this.loadLazy(this.lazyLoadEvent);
      },
      (err: any) => {
        this.isBulkArchiving = false;
        this.alertService.error(err);
      }
    );
  }

  
  unarchiveSelected(): void {
    const mails: any[] = this.selectedMails
      .map((m: any) => m?.data ?? m)
      .filter((m: any) => !!m?.msgId);

    if (mails.length === 0 || this.isBulkUnarchiving) return;
    this.isBulkUnarchiving = true;

    const sentIds:   number[] = mails.filter(m => Number(m.msgOrigin) === 4).map(m => m.msgId);
    const inboxIds:  number[] = mails.filter(m => Number(m.msgOrigin) !== 4).map(m => m.msgId);

    const requests: any[] = [];
    if (inboxIds.length > 0) requests.push(this.msgService.updateMsgsFolder(inboxIds, 0));
    if (sentIds.length  > 0) requests.push(this.msgService.updateMsgsFolder(sentIds,  1));

    forkJoin(requests).subscribe({
      next: () => {
        this.isBulkUnarchiving = false;
        this.messageService.add({ severity: 'success', summary: 'Restored', detail: `${mails.length} message(s) moved back to Inbox / Sent.` });
        this.selectedMails = [];
        this.selectAllCheckbox = false;
        this.inboxs.forEach(x => { if (x?.data) x.data.checkboxFlag = false; });
        this.selectedRow = null;
        this.selectedMailEntry = null;
        this.mailPaneLoading = false;
        this.loadLazy(this.lazyLoadEvent);
      },
      error: (err: any) => {
        this.isBulkUnarchiving = false;
        this.alertService.error(err);
      }
    });
  }

  selectAllCheckboxChanged() {
    this.selectedMails = [];
    if (this.selectAllCheckbox) {
      this.inboxs.forEach(x => {
        x.data.checkboxFlag = true;
        this.selectedMails.push(x);
      });
    }
    else {
      this.inboxs.forEach(x => {
        x.data.checkboxFlag = false;
      });
    }
  }

  getFilteredTags(tags) {
    // if filter text input is empty then load all records
    if (tags == '0') {
      delete this.lazyLoadEvent.filters.msgId;
      this.loadLazy(this.lazyLoadEvent);
    } else {
      // If records found then show filtered records
      if (tags.length > 0) {
        // if filter text input is not empty then load filtered records only
        let filteredMsgIds = [];
        tags.forEach(tag => {
          filteredMsgIds.push(tag.tagSourceId);
        });
        let activityProviderIdFilter = { 'msgId': { 'value': filteredMsgIds, 'matchMode': 'in' } };
        Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
        this.loadLazy(this.lazyLoadEvent);
      } else {
        // Display empty table as no record found with filtered input
        this.inobxes = [];
      }
    }
  }

  openViewTask(rowData: any) {
    if (rowData.taskAPIList?.length > 1) {
      const dialogConfig = new MatDialogConfig();
      // settings
      dialogConfig.width = '100%';
      dialogConfig.height = '100%';
      dialogConfig.maxWidth = '1600px';
      dialogConfig.maxHeight = '800px';
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        title: 'Mail Tasks',
        isModal: true,
        parentMsgId: rowData.msgId,
        fromMail: true,
        showFilter: false,
        showPagination: false,
        outlineNewButton: false,
      };
      const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '100vw';
      dialogConfig.height = '100vh';
      dialogConfig.maxWidth = '100vw';
      dialogConfig.maxHeight = '100vh';
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.data = {
        title: 'Assign Task',
        isModal: true,
        taskApi: rowData?.taskAPIList[0],
        fromMail: false
      };

      const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
      dialogRef.componentInstance.doAdd.subscribe(
        data => {
          console.log('Dialog output:', data);
          this.loadLazy(this.lazyLoadEvent);
          dialogRef.close();
        });
    }
  }

  getNumberOfChildMsg(msg: any) {
    /* if (!msg?.jsonChildMsg || '' === msg?.jsonChildMsg) {
       return 0;
     }
     return JSON.parse(msg?.jsonChildMsg).length;*/
    return msg?.children?.length;

  }

  mailSelectionChanged(msg: any) {
    const index = this.selectedMails.findIndex(x => x.msgId === msg.msgId);
    if (index === -1) {
      this.selectedMails.push(msg);
    }
    else {
      this.selectedMails.splice(index, 1);
    }
  }

  msgSent($event: any) {
    this.selectedMailEntry = null;
    this.loadLazy(this.lazyLoadEvent);
  }

  searchByKeywork($event: any) {
    if (!$event?.target?.value || $event?.target?.value?.length > 2) { // minimum length 3 for serach
      this.loadLazy(this.lazyLoadEvent);
    }
  }
  goToPage() {
    if (!this.goToPageNumber || this.goToPageNumber < 1 || this.goToPageNumber > this.getTotalPages()) {
      return;
    }

    const first = (this.goToPageNumber - 1) * this.rowsPerPage;
    this.pt.first = first;

    const event = {
      first: first,
      rows: this.rowsPerPage,
      filters: this.pt?.filters ?? {}
    };

    this.loadLazy(event);
  }

  archiveMail(mail: any): void {
    const msgId: number = mail?.msgId;
    if (!msgId || this.archivingMsgIds.has(msgId)) return;
    this.archivingMsgIds.add(msgId);
    this.msgService.updateMsgsFolder([msgId], 2).subscribe(
      (res: any) => {
        this.archivingMsgIds.delete(msgId);
        this.onMessageArchived(mail);
      },
      (err: any) => {
        this.archivingMsgIds.delete(msgId);
        this.alertService.error(err);
      }
    );
  }


  
  restoreFromArchive(mail: any): void {
    const msgId: number = mail?.msgId;
    if (!msgId || this.restoringMsgIds.has(msgId)) return;
    const isSent = Number(mail?.msgOrigin) === 4;
    const targetFolder = isSent ? 1 : 0;
    const targetLabel  = isSent ? 'Sent' : 'Inbox';
    this.restoringMsgIds.add(msgId);
    this.msgService.updateMsgsFolder([msgId], targetFolder).subscribe(
      (res: any) => {
        this.restoringMsgIds.delete(msgId);
        const index = this.inboxs.findIndex(m => m?.data?.msgId === msgId);
        if (index !== -1) {
          const updated = [...this.inboxs];
          updated.splice(index, 1);
          this.inboxs = updated;
          const nextIdx = Math.min(index, this.inboxs.length - 1);
          const nextMsg = this.inboxs[nextIdx]?.data;
          if (nextMsg) this.openSelectedMail(nextMsg);
          else this.selectedMailEntry = null;
        }
        this.messageService.add({ severity: 'success', summary: `Moved to ${targetLabel}`, detail: res?.message || `Moved to ${targetLabel}` });
      },
      (err: any) => {
        this.restoringMsgIds.delete(msgId);
        this.alertService.error(err);
      }
    );
  }

  getTotalPages(): number {
    return Math.ceil(this.recordTotal / this.rowsPerPage);
  }

  get showEmailHtml(): boolean {
    if (this.selectedMailEntry?.emailHtml) {
      return true;
    }
    if (!this.selectedMailEntry?.emailHtml && !this.selectedMailEntry?.emailText && !this.selectedMailEntry?.mobileText) {
      return !this.selectedMailEntry?.msgOrigin || this.selectedMailEntry?.msgOrigin !== 4;
    }
    return false;
  }

  get showEmailText(): boolean {
    if (this.selectedMailEntry?.emailText) {
      return true;
    }
    if (!this.selectedMailEntry?.emailHtml && !this.selectedMailEntry?.emailText && !this.selectedMailEntry?.mobileText) {
      return this.selectedMailEntry?.msgOrigin === 4;
    }
    return false;
  }

  get showSms(): boolean {
    return !!this.selectedMailEntry?.mobileText;
  }


  onSearchComplete(event: any) {
    const term = (event.query || '').trim();
    this.searchKeyWork = term;
    if (term.length >= 3) {
      this.searchSuggestions = this.baseSearchFilterOptions.map(opt => ({
        label: `Filter by ${opt.label}`,
        fullLabel: `${term} : Filter by ${opt.label}`,
        value: opt.value,
        term: term
      }));
    } else {
      this.searchSuggestions = [];
    }
  }

  onSearchSuggestionSelect(event: any) {
    const selected = event?.value || event;
    const term = this.searchKeyWork;
    if (!selected || !term || term.length < 3) {
      return;
    }
    this.searchKeyFilter = selected;
    this.searchPlaceholder = `${term} : ${selected?.label}`;
    this.searchKeyWork = term;
    this.saveRecentSearch(term);
    console.log("searchKeyWork", this.searchKeyWork, selected);
    this.searchMessages();
  }

  clearSearch() {
    this.searchKeyWork = '';
    this.searchSuggestions = [];
    this.searchKeyFilter = 'email';
    this.searchPlaceholder = 'Search (min 3 chars)...';
    if (this.lazyLoadEvent) {
      this.loadLazy(this.lazyLoadEvent);
    }
  }


  onSearchFocus() {
    this.searchFocused = true;
    this.loadRecentSearches();
    const inp = document.getElementById('inbox-search-nac') as HTMLInputElement;
    if (inp) { inp.setAttribute('autocomplete', 'new-password'); }
  }

  onSearchBlur() {
    setTimeout(() => { this.searchFocused = false; }, 250);
  }

  private loadRecentSearches() {
    try {
      this.recentSearches = JSON.parse(
        localStorage.getItem(this.RECENT_SEARCHES_KEY) || '[]'
      );
    } catch {
      this.recentSearches = [];
    }
  }

  private saveRecentSearch(term: string) {
    if (!term?.trim() || term.trim().length < 3) { return; }
    this.loadRecentSearches();
    this.recentSearches = [
      term.trim(),
      ...this.recentSearches.filter(t => t !== term.trim())
    ].slice(0, 5);
    localStorage.setItem(this.RECENT_SEARCHES_KEY, JSON.stringify(this.recentSearches));
  }

  removeRecentSearch(term: string, event: Event) {
    event.stopPropagation();
    this.recentSearches = this.recentSearches.filter(t => t !== term);
    localStorage.setItem(this.RECENT_SEARCHES_KEY, JSON.stringify(this.recentSearches));
  }

  applyRecentSearch(term: string) {
    this.searchKeyWork = term;
    this.searchFocused = false;
    if (this.lazyLoadEvent) {
      this.loadLazy(this.lazyLoadEvent);
    }
  }

  // When start date is selected
  onStartDateSelect() {
    if (this.msgStartDate) {
      this.minEndDate = new Date(this.msgStartDate); // Disable previous dates
      if (this.msgEndDate && this.msgEndDate < this.minEndDate) {
        this.msgEndDate = null; // reset end date if it is before start date
      }
      // Automatically open end date calendar
      setTimeout(() => {
        this.endCal.overlayVisible = true; // for PrimeNG v14+
        this.endCal.showOverlay(); // for older versions
      }, 0);
    } else {
      this.minEndDate = null; // allow all dates if start is null
    }
  }

  // When start date is cleared manually
  onStartDateClear() {
    this.minEndDate = null;
  }


  clearDateFilters() {
    this.msgStartDate = null;
    this.msgEndDate = null;
    this.minEndDate = null;
  }

  applyDateFilter() {
    if (this.msgStartDate && !this.msgEndDate) {
      // show a warning message
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select an end date when start date is selected.'
      });
      return; // stop here
    }

    if (this.msgEndDate && !this.msgStartDate) {
      // optionally, also validate the other way around
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select a start date when end date is selected.'
      });
      return;
    }

    // apply date filters and reload the table
    if (!this.lazyLoadEvent) {
      this.lazyLoadEvent = {} as LazyLoadEvent; // in case table has not loaded yet
    }

    // add/update filter values
    this.lazyLoadEvent.filters = this.lazyLoadEvent.filters || {};
    if (this.msgStartDate) {
      this.lazyLoadEvent.filters['msgStartDate'] = {
        value: this.datePipe.transform(this.msgStartDate, 'yyyy-MM-dd'),
        matchMode: 'gte'
      };
    } else {
      delete this.lazyLoadEvent.filters['msgStartDate'];
    }

    if (this.msgEndDate) {
      this.lazyLoadEvent.filters['msgEndDate'] = {
        value: this.datePipe.transform(this.msgEndDate, 'yyyy-MM-dd'),
        matchMode: 'lte'
      };
    } else {
      delete this.lazyLoadEvent.filters['msgEndDate'];
    }
    // reload table
    this.loadLazy(this.lazyLoadEvent);
  }

  searchMessages() {
    // Call your existing backend method to filter mails
    this.loadLazy(this.lazyLoadEvent);
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  isNewSection(index: number): boolean {
    if (index === 0) {
      return true;
    }
    return this.tableData1[index].section !== this.tableData1[index - 1].section;
  }


  send(row: any) {

    if (!row.selectedReservationId) {
      alert('Please select reservation first!');
      return;
    }

    const selectedReservation = this.reservations.find(
      r => r.reservationId === row.selectedReservationId
    );

    console.log('Template ID:', row.templateId);
    console.log('Selected Reservation:', selectedReservation);

    const msgPayload = {
      templateId: row.templateId,
      reservationId: row.selectedReservationId
    }

    try {
      this.formLoading = true;
      this.inboxService.sendEmailToGuest(msgPayload)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Email send Successfully', detail: res.message });
            this.loadLazy(this.lazyLoadEvent);
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the email may have been sent.
            // Keep button disabled to prevent a duplicate email from being triggered.
            console.log('sendEmailToGuest FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });

    } catch (error) {
      this.formLoading = false;
      this.alertService.error(error);
    }

  }


  private startNotificationStream(): void {
    // Don't open the SSE connection if there is no JWT — the server will
    // return a 401 without CORS headers, which the browser surfaces as a
    // misleading "CORS policy" error rather than an auth error.
    let token = '';
    try {
      const stored = localStorage.getItem('currentUser');
      token = stored ? JSON.parse(stored)?.token || '' : '';
    } catch { }
    if (!token) return;

    const controller = new AbortController();
    this.notificationStreamController = controller;
    this.connectNotificationStream(controller, token);
  }

  private connectNotificationStream(controller: AbortController, token: string, retryDelay = 3000): void {
    if (controller.signal.aborted) return;

    const url = `${environment.apiUrl}/notifications/stream`;

    fetch(url, {
      headers: { 'Authorization': `Bearer ${token}` },
      signal: controller.signal
    }).then(response => {
      if (controller.signal.aborted) return;
      // Auth failures will not resolve themselves — stop retrying so the
      // browser does not log repeated "CORS policy" errors masking a 401/403.
      if (response.status === 401 || response.status === 403) {
        controller.abort();
        return;
      }
      if (!response.ok || !response.body) {
        this.scheduleReconnect(controller, token, retryDelay);
        return;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const read = () => {
        reader.read().then(({ done, value }) => {
          if (controller.signal.aborted) return;
          if (done) {
            this.scheduleReconnect(controller, token, retryDelay);
            return;
          }
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (const line of lines) {
            const trimmed = line.trim();
            if (trimmed.startsWith('data:')) {
              const jsonStr = trimmed.slice(5).trim();
              if (jsonStr) {
                try {
                  const data = JSON.parse(jsonStr);
                  this.handleNotifications(Array.isArray(data) ? data : [data]);
                } catch { }
              }
            }
          }
          read();
        }).catch(() => {
          if (!controller.signal.aborted) {
            this.scheduleReconnect(controller, token, retryDelay);
          }
        });
      };
      read();
    }).catch(err => {
      if (err?.name !== 'AbortError') {
        console.log('Notification stream dropped — reconnecting in', retryDelay, 'ms');
        this.scheduleReconnect(controller, token, retryDelay);
      }
    });
  }

  private scheduleReconnect(controller: AbortController, token: string, delay: number): void {
    if (controller.signal.aborted) return;
    setTimeout(() => this.connectNotificationStream(controller, token, delay), delay);
  }

  private handleNotifications(data: any[]): void {
    if (!data || data.length === 0) return;

    // If this page is scoped to a specific msgContext (e.g. /inbox-list-vertical/7),
    // only process notifications whose msgContext matches.
    // If no context is set (e.g. /inbox-list-vertical), show everything.
    const relevant = this.msgContext
      ? data.filter(n => Number(n.msgContext) === Number(this.msgContext))
      : data;

    if (relevant.length === 0) return;

    relevant.forEach(notification => {
      this.notifications.unshift(notification);
      this.notificationCount++;
      // this.messageService.add({
      //   severity: 'info',
      //   summary: notification.senderName || notification.senderEmail || 'New Message',
      //   detail: notification.subject || 'New notification',
      //   life: 3000
      // });

      // If the open conversation matches this notification's thread, inject directly
      if (notification?.msgConversationId && this.conversationComponent) {
        this.conversationComponent.injectNotification(notification);
      }
    });
    // this.playNotificationSound();
    this.changeDetector.detectChanges();
    // Silently refresh the left panel list without disturbing the open email
    if (this.lazyLoadEvent) {
      this.isSilentRefresh = true;
      this.loadLazy(this.lazyLoadEvent);
    }
  }

  private playNotificationSound(): void {
    try {
      const AudioCtx = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (!AudioCtx) return;
      const ctx = new AudioCtx();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.setValueAtTime(660, ctx.currentTime + 0.15);
      gain.gain.setValueAtTime(0.2, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.4);
    } catch (e) { }
  }

  onNotificationClick(notification: any): void {
    const index = this.notifications.indexOf(notification);
    if (index !== -1) {
      this.notifications.splice(index, 1);
      this.notificationCount = Math.max(0, this.notificationCount - 1);
    }
    this.pendingNotificationMsgId = notification.msgId;
    this.loadLazy(this.lazyLoadEvent);
  }

  clearNotifications(): void {
    this.notifications = [];
    this.notificationCount = 0;
  }
}